import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import ForgotPassword from 'screens/components/ForgotPassword';
import * as forgotPasswordService from 'services/forgotPasswordService';

const ForgotPasswordContainer = () => {
  const [isLoading, setLoading] = useState(false);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const { configuration } = useSelector((state: RootState) => state.companyConfiguration);

  const handleSubmit = async (username: string) => {
    setLoading(true);
    try {
      await forgotPasswordService.handleForgotPassword(username, configuration?.userService || '');
      toast.add({ type: 'success', message: t('forgotPassword.successMessage') });
    } catch (error) {
      toast.add({ type: 'danger', message: t('forgotPassword.errorMessage') });
    } finally {
      setLoading(false);
    }
  };

  return <ForgotPassword loading={isLoading} onSubmit={(username: string) => handleSubmit(username)} />;
};

export default ForgotPasswordContainer;
